import React, { useState, Component } from 'react';
import { ChevronRight, CalendarIcon, UsersIcon, MailIcon, PhoneIcon, UserIcon } from 'lucide-react';
export function WeddingBookingSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    guestCount: '',
    howDidYouHear: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = encodeURIComponent('Wedding Viewing Request - Peterson House');
    const body = encodeURIComponent(`Name: ${formData.name}\n` + `Email: ${formData.email}\n` + `Phone: ${formData.phone}\n` + `Preferred Date: ${formData.date}\n` + `Guest Count: ${formData.guestCount}\n` + `How did you hear about us: ${formData.howDidYouHear}\n\n` + `Message:\n${formData.message}`);
    window.location.href = `mailto:weddings@petersonhouse.com.au?subject=${subject}&body=${body}`;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="booking" className="bg-neutral-900 py-20 px-8" data-id="element-323">
      <div className="max-w-3xl mx-auto" data-id="element-324">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-325">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-326" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-327">
            Get Started
          </div>
          <h2 className="font-heading text-5xl font-normal text-white mb-6" data-id="element-328">
            Book a Viewing
          </h2>
          <p className="text-base text-neutral-300 mb-10 leading-relaxed" data-id="element-329">
            Take the first step towards your dream wedding. Fill out the form
            below and our events team will be in touch to arrange your
            personalised venue tour.
          </p>
        </div>

        {/* Booking Form */}
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-330">
          {/* Name and Email Row */}
          <div className="grid md:grid-cols-2 gap-6" data-id="element-331">
            <div data-id="element-332">
              <label htmlFor="name" className="block text-sm text-neutral-300 mb-2" data-id="element-333">
                Your Name *
              </label>
              <div className="relative" data-id="element-334">
                <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-335" />
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} placeholder="Enter your full name" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-336" />
              </div>
            </div>

            <div data-id="element-337">
              <label htmlFor="email" className="block text-sm text-neutral-300 mb-2" data-id="element-338">
                Email Address *
              </label>
              <div className="relative" data-id="element-339">
                <MailIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-340" />
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} placeholder="your@email.com" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-341" />
              </div>
            </div>
          </div>

          {/* Phone and Date Row */}
          <div className="grid md:grid-cols-2 gap-6" data-id="element-342">
            <div data-id="element-343">
              <label htmlFor="phone" className="block text-sm text-neutral-300 mb-2" data-id="element-344">
                Phone Number *
              </label>
              <div className="relative" data-id="element-345">
                <PhoneIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-346" />
                <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="0400 000 000" className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-347" />
              </div>
            </div>

            <div data-id="element-348">
              <label htmlFor="date" className="block text-sm text-neutral-300 mb-2" data-id="element-349">
                Preferred Wedding Date *
              </label>
              <div className="relative" data-id="element-350">
                <CalendarIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-351" />
                <input type="date" id="date" name="date" required value={formData.date} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400" data-id="element-352" />
              </div>
            </div>
          </div>

          {/* Guest Count and How Did You Hear Row */}
          <div className="grid md:grid-cols-2 gap-6" data-id="element-353">
            <div data-id="element-354">
              <label htmlFor="guestCount" className="block text-sm text-neutral-300 mb-2" data-id="element-355">
                Estimated Guest Count *
              </label>
              <div className="relative" data-id="element-356">
                <UsersIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-500" data-id="element-357" />
                <select id="guestCount" name="guestCount" required value={formData.guestCount} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white pl-12 pr-6 py-4 focus:outline-none focus:border-brand-pink transition-colors appearance-none cursor-pointer" data-id="element-358">
                  <option value="" data-id="element-359">Select guest count</option>
                  <option value="50-75" data-id="element-360">50-75 guests</option>
                  <option value="76-100" data-id="element-361">76-100 guests</option>
                  <option value="101-150" data-id="element-362">101-150 guests</option>
                  <option value="151-200" data-id="element-363">151-200 guests</option>
                  <option value="200+" data-id="element-364">200+ guests</option>
                </select>
              </div>
            </div>

            <div data-id="element-365">
              <label htmlFor="howDidYouHear" className="block text-sm text-neutral-300 mb-2" data-id="element-366">
                How did you hear about us? *
              </label>
              <select id="howDidYouHear" name="howDidYouHear" required value={formData.howDidYouHear} onChange={handleChange} className="w-full bg-neutral-800 border border-neutral-600 text-white px-6 py-4 focus:outline-none focus:border-brand-pink transition-colors appearance-none cursor-pointer" data-id="element-367">
                <option value="" data-id="element-368">Please Select</option>
                <option value="Word of Mouth" data-id="element-369">Word of Mouth</option>
                <option value="Social Media" data-id="element-370">Social Media</option>
                <option value="Google Search" data-id="element-371">Google Search</option>
                <option value="Open Day / Offsite Expo" data-id="element-372">
                  Open Day / Offsite Expo
                </option>
                <option value="Online Wedding Directory" data-id="element-373">
                  Online Wedding Directory
                </option>
                <option value="Other" data-id="element-374">Other</option>
              </select>
            </div>
          </div>

          {/* Message */}
          <div data-id="element-375">
            <label htmlFor="message" className="block text-sm text-neutral-300 mb-2" data-id="element-376">
              Additional Information
            </label>
            <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} placeholder="Tell us about your vision for your special day..." className="w-full bg-neutral-800 border border-neutral-600 text-white px-6 py-4 focus:outline-none focus:border-brand-pink transition-colors placeholder-neutral-400 resize-none" data-id="element-377" />
          </div>

          {/* Submit Button */}
          <div className="text-center pt-4" data-id="element-378">
            <button type="submit" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-4 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-379">
              <CalendarIcon size={18} data-id="element-380" />
              Request Viewing
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-381" />
            </button>
          </div>

          <p className="text-center text-sm text-neutral-400 mt-6" data-id="element-382">
            Our team will respond within 48 hours to confirm your viewing
            appointment.
          </p>
        </form>
      </div>
    </section>;
}